/** Hide non-core OPPWA groups via CSS class — no DOM moves (preserves PCI iframes). */
const EXTRA_MARKERS = [
  "brand",
  "country",
  "countrycode",
  "mobile",
  "mobilephone",
  "customermobile",
  "birth",
  "birthdate",
  "oneclick",
  "clicktopay",
  "consent",
  "billingagreement",
  "generalterms",
  "installment",
  "termsandconditions",
  "olp",
  "secureid",
  "emailoraccount",
];

const EXTRA_LABEL_PHRASES = [
  "brand",
  "country code",
  "mobile phone",
  "phone number",
  "date of birth",
  "installment",
  "terms and conditions",
  "terms & conditions",
];

const CORE_MARKERS = ["cardnumber", "cardholder", "expiry", "cvv", "submit"];

function isCoreGroup(className: string): boolean {
  const cls = className.toLowerCase();
  return CORE_MARKERS.some((marker) => cls.includes(marker));
}

function isExtraGroup(className: string, labelText: string): boolean {
  const cls = className.toLowerCase();
  if (EXTRA_MARKERS.some((marker) => cls.includes(marker))) return true;
  return EXTRA_LABEL_PHRASES.some((phrase) => labelText.includes(phrase));
}

function hideExtraElement(el: Element): void {
  if (el instanceof HTMLElement) {
    el.classList.add("credit-card-form__oppwa-extra");
    el.setAttribute("aria-hidden", "true");
  }
}

export function stripExtraOppwaFieldsOnce(container: HTMLElement): void {
  container.querySelectorAll(".wpwl-group").forEach((group) => {
    if (isCoreGroup(group.className)) return;

    const labelText =
      group.querySelector(":scope > .wpwl-label, :scope > label")?.textContent?.toLowerCase().trim() ??
      "";

    if (isExtraGroup(group.className, labelText) || !isCoreGroup(group.className)) {
      hideExtraElement(group);
    }
  });

  container.querySelectorAll(".wpwl-label").forEach((label) => {
    const text = label.textContent?.toLowerCase().trim() ?? "";
    if (EXTRA_LABEL_PHRASES.some((phrase) => text.includes(phrase))) {
      hideExtraElement(label.closest(".wpwl-group") ?? label.parentElement ?? label);
    }
  });

  container.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
    const row = checkbox.closest(".wpwl-group") ?? checkbox.closest("div");
    if (row) hideExtraElement(row);
  });
}

/** Re-run strip briefly after onReady — OPPWA may inject extras slightly late. */
export function stripExtraOppwaFieldsDelayed(container: HTMLElement): void {
  stripExtraOppwaFieldsOnce(container);
  [150, 600, 1500].forEach((ms) => {
    window.setTimeout(() => stripExtraOppwaFieldsOnce(container), ms);
  });
}
